module.exports = __webpack_public_path__ + "img/entrance_thumb.5737c464.jpg";